<button
  *ngIf="control"
  [class]="'ks-checkbox-' + color"
  [class.no-label]="!label"
  [class.checked]="isRadio ? control.value === value : control.value"
  [disabled]="control.disabled"
  (click)="isRadio ? control.setValue(value) : control.setValue(!control.value)"
>
  <label *ngIf="label && color !== 'legacy'" class="ks-checkbox-label ks-mr-4m ks-d-flex">
    <span
      class="ks-pr-2 icons-cards svg-icon-sm"
      *ngIf="iconLabel"
      inlineSVG="{{ iconLabel }}"
    ></span>
    <div class="ks-d-flex" [innerHTML]="label | safe : 'html'"></div
  ></label>
  <input
    [type]="isRadio ? 'radio' : 'checkbox'"
    [formControl]="control"
    [value]="value"
    [checked]="isRadio ? control.value === value : control.value"
    [tabindex]="-1"
    class="ks-checkbox-input"
  />
  <label
    *ngIf="label && color === 'legacy'"
    class="ks-checkbox-label ks-ml-4"
    [innerHTML]="label | safe : 'html'"
  ></label>
</button>
